import ahoy from 'ahoy.js';
import { apiOrigin } from '@/constants';

const urlBase = '/analytics';

export default function () {
  ahoy.configure({
    urlPrefix: apiOrigin,
    // Dummy header which forces the ahoy library to use XHR instead of a form
    // submit which avoids a CORB error in Chrome.
    headers: {
      'X-Ahoy': true,
    },

    visitsUrl: `${urlBase}/visits`,
    eventsUrl: `${urlBase}/events`,
  });
}
